import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Config } from '../Config';
import { ReportLauncher } from '../reports/report-launcher';
import * as Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

@Component({
  selector: 'app-tip-vis-map',
  templateUrl: './tip-vis-map.component.html',
  styleUrls: ['./tip-vis-map.component.css']
})
export class TIPMapComponent implements OnInit, AfterViewInit, OnDestroy {

  private driver: Driver;

  constructor(
    private readonly reportLauncher: ReportLauncher,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.driver = new Driver({
      allowClose: false,
      animate: true,
      opacity: 0.75,
      padding: 5,

      onHighlightStarted: (element) => {
        // Disable pointer events for the current step
        const highlightedElement = element.getNode();
        (highlightedElement as HTMLElement).style.pointerEvents = 'none';
      },
      onDeselected: (element) => {
        // Re-enable pointer events when the step ends
        const deselectedElement = element.getNode();
        (deselectedElement as HTMLElement).style.pointerEvents = '';
      },
    });
  }

  extentConfigs: any[] = [
    {
      toolTip: 'Statewide',
      icon: 'm28.531 12.656-.187-.531-1.156-.344-.344-.562-.187-1.437-.719-.312-.094-.344-.375-.312h-20.219v-1.625l-1.656.844 .219-.312-.656.5-1.375.594-.406 13.906 20.719.094h1.719l.313-.531.5-.25.781 .156 1.375-.562.094-.437 1.75-1.312-1.187-1.437h-.25l-.25-.875-.531-.062-.031-.75v-.375l.406-.25.188-.469-.375-.75.844-.844.719-1.25z',
      color: 'white',
      extent: {
        center: [-77.6362661695295, 40.92039887644528],
        zoom: 8
      },
      extentType: 'static',
      label: 'Statewide Extent'
    },
    {
      toolTip: 'Current Area of Interest',
      icon: 'icon-ui-locate',
      color: 'white',
      extent: async () => await this.getAoi(),
      extentType: 'async-func',
      label: 'AOI'
    }
  ];

  defaultBasemap = {
    'tileUrl': 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile',
    'tileTemplate': '/{level}/{row}/{col}',
    'title': 'Streets'
  };

  basemapList = 'terrain,streets,satellite,hybrid,topo,national-geographic,gray-vector,osm';

  basemapConfigs: any[] = [
    {
      'tileUrl': 'https://services.arcgisonline.com/ArcGIS/rest/services/Elevation/World_Hillshade/MapServer/tile',
      'thumbnailTile': '/15/12358/9365',
      'tileTemplate': '/{level}/{row}/{col}',
      'title': 'Elevation'
    },
    {
      'tileUrl': 'https://gis.penndot.pa.gov/gis/rest/services/basemaps/penndotbasemap/MapServer/tile',
      'thumbnailTile': '/7/48/36',
      'tileTemplate': '/{level}/{row}/{col}',
      'title': 'PennDOT'
    },
    {
      'tileUrl': 'https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile',
      'thumbnailTile': '/7/48/36',
      'tileTemplate': '/{level}/{row}/{col}',
      'title': 'Topographic DRG'
    }
  ];

  @ViewChild('map', { static: false }) private mapRef: ElementRef<any>;
  @ViewChild('extent', { static: false }) private extentRef: ElementRef<any>;
  @ViewChild('basemapSwitcher', { static: false }) private basemapSwitcherRef: ElementRef<any>;
  @ViewChild('aoiWindow', { static: false }) private aoiWindowRef: ElementRef<any>;
  @ViewChild('legendWindow', { static: false }) private legendWindowRef: ElementRef<any>;
  @ViewChild('legend', { static: false }) private legendRef: ElementRef<any>;
  @ViewChild('identify', { static: false }) private identifyRef: ElementRef<any>;
  @ViewChild('customIdentifyWindow', { static: false }) private customIdentifyWindowRef: ElementRef<any>;

  public config = (window as any).config as Config;
  layerService: any;
  readonly aoiTypesWithReport = ['state', 'district', 'county', 'houseDistrict', 'congressionalDistrict', 'senateDistrict', 'planningPartner', 'municipality'];
  enableSummaryReportBtn = false;

  previouslyIdentifiedObjectId = '';
  selectedCustomFeature: {
    projectTitle: string,
    projectId: string,
    oneMapUrl: string,
    district: string,
    projectClassName: string,
    planningPartner: string,
    stateRep: string,
    stateSenator: string,
    usRep: string,
    countyName: string,
    route: string,
    isTIP: string,
    isDecadeProject: string,
    pmName: string,
    pmEmail: string,
    pmPhone: string,
    county: string,
    segment: string,
    offset: string,
    hasNext: boolean,
    hasPrev: boolean,
    airportName: string,
    airportId: string,
    description: string,
    fedFiscalYear: string,
    stateFiscalYear: string,
    fedShare: string,
    stateShare: string,
    localShare: string,
    transitAgency: string,
    mpmsNumber: string,
    totalProjectCost: string
  } = {
      projectTitle: '',
      projectId: '',
      oneMapUrl: '',
      district: '',
      projectClassName: '',
      planningPartner: '',
      stateRep: '',
      stateSenator: '',
      usRep: '',
      countyName: '',
      route: '',
      isTIP: '',
      isDecadeProject: '',
      pmName: '',
      pmEmail: '',
      pmPhone: '',
      county: '',
      segment: '',
      offset: '',
      hasNext: false,
      hasPrev: false,
      airportName: '',
      airportId: '',
      description: '',
      fedFiscalYear: '',
      stateFiscalYear: '',
      fedShare: '',
      stateShare: '',
      localShare: '',
      transitAgency: '',
      mpmsNumber: '',
      totalProjectCost: ''
    };
  featureCount = 0;
  curFeatureIndex = 0;
  projectType: 'TYP' | 'TIP' | 'AOI' | 'AVIATION' | 'TRANSIT' = null;
  projectPreTitle = '';
  headerColor = '';
  headerTextColor = '';

  isMobileView = false;
  zoomLevel = 7;
  expanderTopPx = '10px';
  aoiHeight = '';
  aoiWidth = '875';
  showMobileLegend = false;
  isLegendReady = false;
  showMobileIdentify = false;
  showLeftArrow = false;
  showRightArrow = false;

  readonly activateAOITab: Subject<void> = new Subject<void>();
  readonly openVL: Subject<{ countyCode: string, stateRouteNumber: string, segmentNumber: string, offset?: string | number }> =
    new Subject<{ countyCode: string, stateRouteNumber: string, segmentNumber: string, offset?: string | number }>();
  readonly openSV: Subject<{ countyCode: string, stateRouteNumber: string, segmentNumber: string, offset?: string | number }> =
    new Subject<{ countyCode: string, stateRouteNumber: string, segmentNumber: string, offset?: string | number }>();
  readonly openSW: Subject<any> = new Subject<any>();
  readonly deeplinkPresent: Subject<void> = new Subject<void>();
  readonly aoiGo: Subject<void> = new Subject<void>();
  readonly returnAOIInfo: Subject<string> = new Subject<string>();
  readonly openOM: Subject<void> = new Subject<void>();

  async ngOnInit() {
    if (window.location.href.includes('?showMobile=true')) {
      this.isMobileView = true;
      this.zoomLevel = 6;
      this.expanderTopPx = '0';

      // force the mobile page to be landscape
      this.updateOrientationStyles();

      // Set aoi height
      this.aoiHeight = '100vh';
      this.aoiWidth = '100%';
    }
  }

  async ngAfterViewInit() {
    await this.setBaseMap();
    await this.setupBasemapSwitcher();
    await this.constructExtent();

    this.openAOI(true);

    await this.loadMapLayers();

    /* If deeplinks are present */
    if (this.mapRef.nativeElement.DeepLinkService.deepLinkParamIsPresent()) {
      this.deeplinkPresent.next();
    }

    if (this.isMobileView) {
      // Listen for orientation changes
      screen.orientation.addEventListener('change', this.updateOrientationStyles);

      // Listen for mobile legend scrolling
      const scrollLeftButton = document.getElementById('scroll-left');
      const scrollRightButton = document.getElementById('scroll-right');

      scrollLeftButton.addEventListener('click', () => this.scrollLegend('left'));
      scrollRightButton.addEventListener('click', () => this.scrollLegend('right'));

      // format the legend horizontally
      this.legendRef.nativeElement.setHorizontalFormat();
      this.isLegendReady = true;
      this.cdr.detectChanges();
      setTimeout(() => {
        this.toggleLegendWindow();
      }, 10);

      this.checkScrollArrows(); // Check on initialization
      const legendScroll = document.querySelector('.legend-scroll') as HTMLElement;
      if (legendScroll) {
        legendScroll.addEventListener('scroll', () => this.checkScrollArrows());
        window.addEventListener('resize', () => this.checkScrollArrows());
      }

      // first timer tour
      const currentVersion = this.config.version;
      const visitedVersion = localStorage.getItem('visitedVersion');
      const isFirstVisit = !visitedVersion || visitedVersion !== currentVersion;
      if (isFirstVisit) {
        localStorage.setItem('visitedVersion', currentVersion);
        this.startTour();
      }

      await this.setUpCurrentLocation();
    }

    this.identifyRef.nativeElement.addEventListener('featureUpdated', (event) => {
      const existingLinkBtn = document.getElementById('report-links');
      if (existingLinkBtn) {
        existingLinkBtn.remove();
      }
      this.updateCustomIdentifyWindow(event.detail);
    });

  }

  ngOnDestroy() {
    this.mapRef.nativeElement.disposeMap();
  }

  async setBaseMap() {
    await this.mapRef.nativeElement.ready;
    await this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
  }

  async constructExtent() {
    await this.extentRef.nativeElement.ready;
    for (const extentConfig of this.extentConfigs) {
      this.extentRef.nativeElement.addExtentConfiguration(extentConfig);
    }
  }

  async setupBasemapSwitcher() {
    await this.basemapSwitcherRef.nativeElement.ready;
    this.basemapSwitcherRef.nativeElement.addBasemaps(this.basemapList, this.basemapConfigs);
  }

  openAOI(isStartup = false) {
    this.activateAOITab.next();
    if (!this.isMobileView || (this.isMobileView && !isStartup)) {
      this.aoiWindowRef.nativeElement.open();
    }
  }

  closeAOIWindow() {
    this.aoiWindowRef.nativeElement.close();
  }

  AOISelected(aoiType: string[]) {
    this.closeAOIWindow();
    if (!this.isMobileView && !this.legendWindowRef.nativeElement.isOpened) {
      this.legendWindowRef.nativeElement.open();
    } else if (this.isMobileView && !this.showMobileLegend) {
      this.showMobileLegend = true;
      this.toggleMobileLegend();
    }

    let externalLayerUrlIdArr: string[] = ['7', '8', '10', '11', '23', '24'];
    /* don't make aviation & transit points visible when aoiType is interstate because
       they are not on the interstate and don't have st_rt_no column to compare to */
    if (aoiType[0] === 'route' && aoiType[1] === undefined) {
      externalLayerUrlIdArr = ['10', '11', '23', '24'];
    }

    const loadedLayers = this.mapRef.nativeElement.LayerService.mapLayers;
    for (const featureLayer of loadedLayers.feature) {
      const foundId = externalLayerUrlIdArr.filter(x => featureLayer.mapcoreProps.url.includes(x));
      if (foundId.length > 0) {
        featureLayer.mapcoreProps.visible = true;
        featureLayer.visible = true;
      }
    }

    if (this.aoiTypesWithReport.includes(aoiType[0])) {
      this.enableSummaryReportBtn = true;
    } else {
      this.enableSummaryReportBtn = false;
    }

    /* change county aoi label to name instead of number value */
    if (aoiType[0] === 'county') {
      const countyLayerIndex: number = loadedLayers.mapImage.findIndex(l => l.mapcoreProps.description === 'PA counties');
      if (countyLayerIndex > -1) {
        const lowerCaseStr = aoiType[1].toLowerCase();
        const countyName = lowerCaseStr.charAt(0).toUpperCase() + lowerCaseStr.slice(1);
        loadedLayers.mapImage[countyLayerIndex].mapcoreProps.name = 'County: ' + countyName;
      }
    }

    this.mapRef.nativeElement.LayerService.refreshLayers();
    this.aoiGo.next();
  }

  async getAoi() {
    const aoiLayer = this.mapRef.nativeElement.LayerService.getAoiLayers();
    if (aoiLayer.length) {
      const aoiExtent = await this.mapRef.nativeElement.LayerService.getLayerExtent(aoiLayer[0]);
      return aoiExtent;
    }
  }

  toggleLegendWindow() {
    if (!this.isMobileView) {
      if (this.legendWindowRef.nativeElement.isOpened) {
        this.legendWindowRef.nativeElement.close();
      } else {
        this.legendWindowRef.nativeElement.open();
      }
    } else {
      this.showMobileLegend = !this.showMobileLegend;
      if (!this.showMobileLegend) {
        this.legendRef.nativeElement.collapseAll();
      }
      this.toggleMobileLegend();
    }
  }

  async loadMapLayers() {
    this.layerService = this.mapRef.nativeElement.LayerService;
    const y = new Date().getFullYear().toString();

    try {
      /* Add Transit layer */
      let layerProps = await this.layerService.getExternalServiceProperties({ url: this.config.layerURLs.tipLayers.transitUrl });
      layerProps.visible = false;
      await this.layerService.addExternalLayersToMap(layerProps);

      /* Add Aviation layer */
      layerProps = await this.layerService.getExternalServiceProperties({ url: this.config.layerURLs.tipLayers.aviationUrl });
      layerProps.visible = false;
      await this.layerService.addExternalLayersToMap(layerProps);

      /* Add and group TYP Layers */
      let layerProps1 = await this.layerService.getExternalServiceProperties({ url: this.config.layerURLs.tipLayers.typLinesUrl });
      layerProps1.visible = false;
      let featureLayer1 = await this.layerService.addExternalLayersToMap(layerProps1);
      featureLayer1.mapcoreProps.groupParent = { isOpen: false, name: 'Twelve Year Program (TYP)', visible: true };

      let layerProps2 = await this.layerService.getExternalServiceProperties({ url: this.config.layerURLs.tipLayers.typPointsUrl });
      layerProps2.visible = false;
      let featureLayer2 = await this.layerService.addExternalLayersToMap(layerProps2);
      featureLayer2.mapcoreProps.groupParent = { isOpen: false, name: 'Twelve Year Program (TYP)', visible: true };

      let l = [featureLayer1, featureLayer2];
      await this.layerService.groupLayers(l);

      /* Add and group TIP Layers */
      layerProps1 = await this.layerService.getExternalServiceProperties({ url: this.config.layerURLs.tipLayers.tipLinesUrl });
      layerProps1.visible = false;
      featureLayer1 = await this.layerService.addExternalLayersToMap(layerProps1);
      featureLayer1.mapcoreProps.groupParent = { isOpen: false, name: 'TIP', visible: true };

      layerProps2 = await this.layerService.getExternalServiceProperties({ url: this.config.layerURLs.tipLayers.tipPointsUrl });
      layerProps2.visible = false;
      featureLayer2 = await this.layerService.addExternalLayersToMap(layerProps2);
      featureLayer2.mapcoreProps.groupParent = { isOpen: false, name: 'TIP', visible: true };

      l = [featureLayer1, featureLayer2];
      await this.layerService.groupLayers(l);

    } catch (error) {
      // this.loggingService.Log(`Error Loading External Layer '${selected.name}'`, error, LogLevel.Error);
    }
  }

  openVideoLog(e: Event) {
    const CRS: { countyCode: string, offset: string, segmentNumber: string, stateRouteNumber: string } = {
      countyCode: this.selectedCustomFeature.county,
      stateRouteNumber: this.selectedCustomFeature.route,
      segmentNumber: this.selectedCustomFeature.segment,
      offset: this.selectedCustomFeature.offset
    };
    this.openVL.next(CRS);
  }

  openShareWindow() {
    const aoiLayer = this.mapRef.nativeElement.LayerService.getAoiLayers();
    this.openSW.next(aoiLayer);
  }

  openSummaryReport() {
    const aoiLayer = this.mapRef.nativeElement.LayerService.getAoiLayers();
    const url = this.generateSummaryReportURL(aoiLayer);
    window.open(url);
  }

  openProjectReport(reportType: string) {
    let url = this.config.url + 'project-report?reportType=' + reportType + '&';

    if (reportType === 'Aviation' || reportType === 'Project') {
      url += 'ProjectID';
    } else if (reportType === 'Transit') {
      url += 'ObjectID';
    }

    url += '=' + this.selectedCustomFeature.projectId;
    window.open(url);
  }

  generateSummaryReportURL(aoiLayer: any): string {
    let shareStr = this.config.url + 'summary-report?reportType=tipvis';

    if (aoiLayer.length && aoiLayer[0].mapcoreProps && aoiLayer[0].mapcoreProps.query) {
      const selectedAOIQuery: {
        subqueries?: { field: string, operator: string, value: string, subqueries?: any[] }[],
        field: string,
        operator: string,
        value: string
      } = aoiLayer[0].mapcoreProps.query.subqueries[0];

      if (!selectedAOIQuery.subqueries) {
        if (selectedAOIQuery.field === 'COUNTY_NUMBER') {
          shareStr += '&cn=' + selectedAOIQuery.value;
        } else if (selectedAOIQuery.field === 'DISTRICT_NUMBER') {
          shareStr += '&dist=' + selectedAOIQuery.value;
        } else if (selectedAOIQuery.field === 'PLN_PRTNR_SHRTNM') {
          shareStr += '&mporpo=' + selectedAOIQuery.value;
        } else if (selectedAOIQuery.field === 'LEG_DISTRICT_NO') {
          if (aoiLayer[0].mapcoreProps.name.toLowerCase().includes('house')) {
            shareStr += '&houseDistrictNumber=' + selectedAOIQuery.value;
          } else if (aoiLayer[0].mapcoreProps.name.toLowerCase().includes('senate')) {
            shareStr += '&senateDistrictNumber=' + selectedAOIQuery.value;
          } else if (aoiLayer[0].mapcoreProps.name.toLowerCase().includes('congressional')) {
            shareStr += '&congressDistrictNumber=' + selectedAOIQuery.value;
          }
        } else {
          // not a reported aoi
          shareStr = '';
        }
      } else {
        let count = 0;
        for (const query of selectedAOIQuery.subqueries) {
          if (count >= 0) {
            shareStr += '&';
          }

          if (query.field.toUpperCase() === 'CTY_CODE' || query.field.toUpperCase() === 'COUNTY') {
            shareStr += 'cn=' + query.value;
          } else if (query.field.toUpperCase() === 'MUNICIPAL_CODE') {
            shareStr += 'muni=' + query.value;
          } else if (query.field.toUpperCase() === 'ST_RT_NO' ||
            query.field.toUpperCase() === 'PA_CTY_CODE' ||
            query.field.toUpperCase() === 'SCHOOL_DISTRICT') {
            // not a reported aoi
            shareStr = '';
            break;
          } else {
            count--;
          }
          count++;
        }
      }
    } else {
      shareStr += '&aoiType=state';
    }
    return shareStr;
  }

  updateCustomIdentifyWindow(feature) {
    if (!feature || !feature.attributes || !feature.layer || !feature.layer.mapcoreProps) {
      return;
    }
    if (!this.isMobileView && !this.customIdentifyWindowRef.nativeElement.isOpened) {
      this.customIdentifyWindowRef.nativeElement.open();
    } else if (this.isMobileView) {
      this.showMobileIdentify = true;
    }

    if (feature.layerName === 'Aviation Points') {
      this.projectType = 'AVIATION';
      this.selectedCustomFeature.airportName = feature.attributes.filter(x => x.columnName === 'AIRPORT_NAME')[0].value ?
        feature.attributes.filter(x => x.columnName === 'AIRPORT_NAME')[0].value.toString() : '';
      this.selectedCustomFeature.airportId = feature.attributes.filter(x => x.columnName === 'ID')[0].value.toString() ?
        feature.attributes.filter(x => x.columnName === 'ID')[0].value.toString() : '';
      this.selectedCustomFeature.projectId = feature.attributes.filter(x => x.columnName === 'PROJECT_ID')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PROJECT_ID')[0].value.toString() : '';
      this.selectedCustomFeature.description = feature.attributes.filter(x => x.columnName === 'DESCRIPTION')[0].value ?
        feature.attributes.filter(x => x.columnName === 'DESCRIPTION')[0].value.toString() : '';
      this.selectedCustomFeature.fedFiscalYear = feature.attributes.filter(x => x.columnName === 'FEDERAL_FISCAL_YEAR')[0].value ?
        feature.attributes.filter(x => x.columnName === 'FEDERAL_FISCAL_YEAR')[0].value.toString() : '';
      this.selectedCustomFeature.stateFiscalYear = feature.attributes.filter(x => x.columnName === 'STATE_FISCAL_YEAR')[0].value ?
        feature.attributes.filter(x => x.columnName === 'STATE_FISCAL_YEAR')[0].value.toString() : '';
      this.selectedCustomFeature.fedShare =
        this.formatCurrency(feature.attributes.filter(x => x.columnName === 'FEDERAL_SHARE')[0].value !== null ?
          feature.attributes.filter(x => x.columnName === 'FEDERAL_SHARE')[0].value.toString() : '0');
      this.selectedCustomFeature.stateShare =
        this.formatCurrency(feature.attributes.filter(x => x.columnName === 'STATE_SHARE')[0].value !== null ?
          feature.attributes.filter(x => x.columnName === 'STATE_SHARE')[0].value.toString() : '0');
      this.selectedCustomFeature.localShare =
        this.formatCurrency(feature.attributes.filter(x => x.columnName === 'LOCAL_SHARE')[0].value !== null ?
          feature.attributes.filter(x => x.columnName === 'LOCAL_SHARE')[0].value.toString() : '0');

    } else if (feature.layerName === 'Transit') {
      this.projectType = 'TRANSIT';
      this.selectedCustomFeature.transitAgency = feature.attributes.filter(x => x.columnName === 'AGENCY')[0].value ?
        feature.attributes.filter(x => x.columnName === 'AGENCY')[0].value.toString() : '';
      this.selectedCustomFeature.projectTitle = feature.attributes.filter(x => x.columnName === 'PROJECT_TITLE')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PROJECT_TITLE')[0].value.toString() : '';
      this.selectedCustomFeature.mpmsNumber = feature.attributes.filter(x => x.columnName === 'PROJECT_ID')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PROJECT_ID')[0].value.toString() : '';
      this.selectedCustomFeature.stateFiscalYear = feature.attributes.filter(x => x.columnName === 'STATE_FISCAL_YEAR')[0].value ?
        feature.attributes.filter(x => x.columnName === 'STATE_FISCAL_YEAR')[0].value.toString() : '';
      this.selectedCustomFeature.totalProjectCost =
        this.formatCurrency(feature.attributes.filter(x => x.columnName === 'TOTAL_PROJECT_COST')[0].value !== null ?
          feature.attributes.filter(x => x.columnName === 'TOTAL_PROJECT_COST')[0].value.toString() : '0');
      this.selectedCustomFeature.projectId = feature.attributes.filter(x => x.columnName === 'OBJECTID')[0].value !== null ?
        feature.attributes.filter(x => x.columnName === 'OBJECTID')[0].value.toString() : '-1';

    } else if (feature.sourceLayer) {
      this.projectType = 'AOI';
      this.selectedCustomFeature.projectTitle = feature.layerName ? feature.layerName : feature.sourceLayer.title;
      this.selectedCustomFeature.projectId = '';
      this.selectedCustomFeature.oneMapUrl = '';
      this.selectedCustomFeature.projectClassName = '';
      this.selectedCustomFeature.district = '';
      this.selectedCustomFeature.planningPartner = '';
      this.selectedCustomFeature.stateRep = '';
      this.selectedCustomFeature.stateSenator = '';
      this.selectedCustomFeature.usRep = '';
      this.selectedCustomFeature.countyName = '';
      this.selectedCustomFeature.route = '';
      this.selectedCustomFeature.isTIP = '';
      this.selectedCustomFeature.isDecadeProject = '';
      this.selectedCustomFeature.pmName = '';
      this.selectedCustomFeature.pmPhone = '';
      this.selectedCustomFeature.pmEmail = '';
      this.selectedCustomFeature.county = '';
      this.selectedCustomFeature.segment = '';
      this.selectedCustomFeature.offset = '';

    } else {
      this.selectedCustomFeature.projectTitle = feature.attributes.filter(x => x.columnName === 'PROJ_TITLE')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PROJ_TITLE')[0].value.toString() : '';
      const projectId = feature.attributes.filter(x => x.columnName === 'PROJ_ID')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PROJ_ID')[0].value.toString() : '';
      this.selectedCustomFeature.projectId = projectId;
      this.selectedCustomFeature.oneMapUrl = this.config.oneMapUrl + '?ProjectID=' + projectId;
      this.selectedCustomFeature.projectClassName = feature.attributes.filter(x => x.columnName === 'PROJECT_CLASS_NAME')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PROJECT_CLASS_NAME')[0].value.toString() : '';
      this.selectedCustomFeature.district = feature.attributes.filter(x => x.columnName === 'DISTRICT_NO')[0].value ?
        feature.attributes.filter(x => x.columnName === 'DISTRICT_NO')[0].value.toString() : '';
      this.selectedCustomFeature.planningPartner = feature.attributes.filter(x => x.columnName === 'PLAN_PRTNR_SHRTNM')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PLAN_PRTNR_SHRTNM')[0].value.toString() : '';
      this.selectedCustomFeature.stateRep = feature.attributes.filter(x => x.columnName === 'HOUSE_LEGISLATOR_NAME')[0].value ?
        feature.attributes.filter(x => x.columnName === 'HOUSE_LEGISLATOR_NAME')[0].value.toString() : '';
      this.selectedCustomFeature.stateSenator = feature.attributes.filter(x => x.columnName === 'SENATE_LEGISLATOR_NAME')[0].value ?
        feature.attributes.filter(x => x.columnName === 'SENATE_LEGISLATOR_NAME')[0].value.toString() : '';
      this.selectedCustomFeature.usRep = feature.attributes.filter(x => x.columnName === 'CONGRESS_LEGISLATOR_NAME')[0].value ?
        feature.attributes.filter(x => x.columnName === 'CONGRESS_LEGISLATOR_NAME')[0].value.toString() : '';
      this.selectedCustomFeature.countyName = feature.attributes.filter(x => x.columnName === 'COUNTY_NAME')[0].value ?
        feature.attributes.filter(x => x.columnName === 'COUNTY_NAME')[0].value.toString() : '';
      this.selectedCustomFeature.route = feature.attributes.filter(x => x.columnName === 'ST_RT_NO')[0].value ?
        feature.attributes.filter(x => x.columnName === 'ST_RT_NO')[0].value.toString() : '';
      this.selectedCustomFeature.isTIP = feature.attributes.filter(x => x.columnName === 'TIP_APPR_IND')[0].value ?
        feature.attributes.filter(x => x.columnName === 'TIP_APPR_IND')[0].value.toString() : '';
      this.selectedCustomFeature.isDecadeProject = feature.attributes.filter(x => x.columnName === 'DCD_OF_INVSTMNT_FL')[0].value ?
        feature.attributes.filter(x => x.columnName === 'DCD_OF_INVSTMNT_FL')[0].value.toString() : '';

      this.selectedCustomFeature.pmName = feature.attributes.filter(x => x.columnName === 'PRJCT_MNGR_CONTACT_NM')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PRJCT_MNGR_CONTACT_NM')[0].value.toString() : '';
      const phoneNumber: string = feature.attributes.filter(x => x.columnName === 'PRJCT_MNGR_NO')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PRJCT_MNGR_NO')[0].value.toString() : '';
      this.selectedCustomFeature.pmPhone = phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, 6) + '-' +
        phoneNumber.substring(6, 10);
      this.selectedCustomFeature.pmEmail = feature.attributes.filter(x => x.columnName === 'PRJCT_MNGR_EMAIL')[0].value ?
        feature.attributes.filter(x => x.columnName === 'PRJCT_MNGR_EMAIL')[0].value.toString() : '';

      if (this.selectedCustomFeature.isTIP === 'Y') {
        this.projectType = 'TIP';
      } else if (feature.attributes.filter(x => x.columnName === 'TYP_APPR_IND')[0].value.toString() === 'Y') {
        this.projectType = 'TYP';
      }

      this.selectedCustomFeature.county = feature.attributes.filter(x => x.columnName === 'CTY_CODE')[0].value ?
        feature.attributes.filter(x => x.columnName === 'CTY_CODE')[0].value.toString() : '';
      this.selectedCustomFeature.offset = feature.attributes.filter(x => x.columnName === 'OFFSET_BGN')[0].value ?
        feature.attributes.filter(x => x.columnName === 'OFFSET_BGN')[0].value.toString() : '';
      this.selectedCustomFeature.segment = feature.attributes.filter(x => x.columnName === 'SEG_BGN')[0].value ?
        feature.attributes.filter(x => x.columnName === 'SEG_BGN')[0].value.toString() : '';
    }
    this.selectedCustomFeature.hasNext = this.identifyRef.nativeElement.getHasNextFeature();
    this.selectedCustomFeature.hasPrev = this.identifyRef.nativeElement.getHasPreviousFeature();

    const countAndIndex: number[] = this.identifyRef.nativeElement.getFeatureCountAndIndex();
    this.featureCount = countAndIndex[0];
    this.curFeatureIndex = countAndIndex[1] + 1;

    if (this.projectType === 'TIP') {
      this.projectPreTitle = 'TIP Project - ';
      this.headerColor = '#EAEAEA';
      this.headerTextColor = '#337AB7';
    } else if (this.projectType === 'TYP') {
      this.projectPreTitle = 'TYP Project - ';
      this.headerColor = '#EAEAEA';
      this.headerTextColor = '#337AB7';
    } else if (this.projectType === 'AVIATION') {
      this.projectPreTitle = 'Aviation Project - ';
      this.headerColor = '#EAEAEA';
      this.headerTextColor = '#337AB7';
      this.selectedCustomFeature.projectTitle = this.selectedCustomFeature.airportName;
    } else if (this.projectType === 'TRANSIT') {
      this.projectPreTitle = 'Transit Project - ';
      this.headerColor = '#EAEAEA';
      this.headerTextColor = '#337AB7';
    } else {
      this.projectPreTitle = '';
      this.headerColor = '#000000';
      this.headerTextColor = '#FFFFFF';
    }
    this.cdr.detectChanges();
  }

  formatCurrency(amount: number): string {
    // Convert number to string and add commas for thousands separator
    const formattedAmount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Add currency symbol and return
    return '$' + formattedAmount;
  }

  prevFeature() {
    this.identifyRef.nativeElement.previousFeature();
  }
  nextFeature() {
    this.identifyRef.nativeElement.nextFeature();
  }

  filterInterstate(routeNumber: string) {
    const loadedLayers = this.mapRef.nativeElement.LayerService.mapLayers;
    for (const featureLayer of loadedLayers.feature) {
      const externalLayerId = featureLayer.id;
      const esriLayer = this.layerService.getEsriLayerByUniqueId(externalLayerId);
      esriLayer.mapcoreProps.filter = 'st_rt_no = \'' + routeNumber + '\'';
      esriLayer.mapcoreProps.query = {
        childTableQuery: {
          operator: 'AND'
        },
        childTableRecord: undefined,
        field: 'st_rt_no',
        joinRecord: undefined,
        joinTableQuery: {
          operator: 'AND'
        },
        operator: '=',
        primaryLayerRMSKeys: undefined,
        value: routeNumber
      };
      esriLayer.definitionExpression = 'st_rt_no = \'' + routeNumber + '\'';
    }
  }
  clearFilter() {
    const loadedLayers = this.mapRef.nativeElement.LayerService.mapLayers;
    for (const featureLayer of loadedLayers.feature) {
      const externalLayerId = featureLayer.id;
      const esriLayer = this.layerService.getEsriLayerByUniqueId(externalLayerId);
      esriLayer.mapcoreProps.filter = '';
      esriLayer.mapcoreProps.query = {
        childTableQuery: {
          operator: 'AND'
        },
        childTableRecord: undefined,
        field: '',
        joinRecord: undefined,
        joinTableQuery: {
          operator: 'AND'
        },
        operator: '=',
        primaryLayerRMSKeys: undefined,
        value: ''
      };
      esriLayer.definitionExpression = '';
    }
  }

  updateOrientationStyles() {
    if (screen.orientation.type.startsWith('portrait')) {
      document.body.style.transform = 'rotate(-90deg)';
      document.body.style.transformOrigin = 'center';
      document.body.style.width = '100vh';
      document.body.style.height = '100vw';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.transform = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.overflow = '';
    }
  }

  checkScrollArrows() {
    const legendScroll = document.querySelector('.legend-scroll') as HTMLElement;

    if (legendScroll) {
      this.showLeftArrow = legendScroll.scrollLeft > 0;
      this.showRightArrow =
        legendScroll.scrollLeft + legendScroll.clientWidth < legendScroll.scrollWidth;
    }
  }

  scrollLegend(direction: 'left' | 'right') {
    const legendScroll = document.querySelector('.legend-scroll') as HTMLElement;
    const scrollAmount = 150;
    if (legendScroll) {
      if (direction === 'left') {
        legendScroll.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        legendScroll.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }

      // Add a short delay to ensure arrows reflect the updated scroll position
      setTimeout(() => this.checkScrollArrows(), 300);
    }
  }

  toggleMobileLegend() {
    const legendContainer = document.getElementById('mLegendContainer');
    if (legendContainer) {
      legendContainer.classList.toggle('active');
    }
  }

  getAOIInfo() {
    // get aoi infor for mobile report/email
    const aoiLayer = this.mapRef.nativeElement.LayerService.getAoiLayers();

    // return data to nav
    if (aoiLayer) {
      const aoiStr = this.generateSummaryReportURL(aoiLayer);
      this.returnAOIInfo.next(aoiStr);
    }
  }

  closeMobileIdentify() {
    this.showMobileIdentify = false;
  }

  async setUpCurrentLocation(): Promise<void> {
    const mapView = this.mapRef.nativeElement.mapView;

    // Ensure ArcGIS script is loaded
    await this.loadArcGISScript();

    // Use Dojo's require after ArcGIS script is loaded
    (window as any).require(['esri/widgets/Locate'], (Locate: any) => {
      const locate = new Locate({ view: mapView });
      mapView.ui.add(locate, 'top-right');

      // 'north' the mapview
      locate.on('locate', () => {
        mapView.goTo({ rotation: 0 });
      });
    });
  }

  private loadArcGISScript(): Promise<void> {
    // manually pull in the script for now, could not get it to build locally
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://js.arcgis.com/4.29/';
      script.onload = () => resolve();
      script.onerror = (error) => reject(error);
      document.body.appendChild(script);
    });
  }

  startTour() {
    const mapElement = document.querySelector('#map');
    const mapNav = document.getElementById('map-nav');
    const optionsMenu = document.getElementById('options-menu');
    const legendElement = document.getElementById('mLegendContainer');

    // Manually query the shadow DOM (if applicable)
    const shadowHost = document.querySelector('#shadow-host') as HTMLElement;
    if (shadowHost && shadowHost.shadowRoot) {
      const shadowMapElement = shadowHost.shadowRoot.querySelector('#map');
      // console.log("Found map inside shadow root:", shadowMapElement);
    }

    this.driver.defineSteps([
      {
        element: mapElement,
        popover: {
          title: 'Welcome to PAProjects!',
          description: `This will give you a quick overview of what is new in PAProject's new mobile release.`

        }
      },
      {
        element: mapNav,
        popover: {
          title: 'Four & Twelve Year Plan Map',
          description: 'The State Transportation Improvement Plan (STIP) and the Transportation Improvement Program (TIP) are the first four years of the Twelve Year Program (TYP). The STIP being the culmination of the 23 planning regions and one independent county in PA. Federal Law requires TIPS be updated at least every four years.'

        },
        onNext: this.toggleOptionsMenu // open
      },

      {
        element: optionsMenu,
        popover: {
          title: 'Options Menu',
          description: 'From this menu you can Select an Area of Interest (AOI) to view on the map. After choosing your AOI, a new Summary Report option will appear here. Select that option to opt in for an email with the AOIs construction summary data. Select Contact & About Map to learn more about each.'
        },
        onNext: this.toggleOptionsMenu, // close
        onPrevious: this.toggleOptionsMenu // close
      },
      {
        element: legendElement,
        popover: {
          title: 'Legend',
          description: 'The Legend will list the features appearing in the map. It will allow you to toggle on/off each item. Should the items expand past the end of the screen, the legend will gain arrows to scroll through the list of legend items. You may click the blue legend button to toggle showing/hiding the legend.'
        },
        onPrevious: this.toggleOptionsMenu // open
      },
      {
        element: mapElement,
        popover: {
          title: 'Map Buttons',
          description: `The map host two buttons. In the top left, select the basemap button to look through a list of basemaps and choose a new basemap. In the top right, select the Find My Location button to zoom to your device's location.`

        }
      }
      // Add more steps as needed
    ]);

    // Start the tour
    this.driver.start();
  }

  toggleOptionsMenu = () => {
    this.openOM.next();
  }
}
